module.exports = __webpack_public_path__ + "media/src/Shared/Assets/roadpass_pro_logo-01e0faa9128e74b10de48974c8ccf3bcde36aa8928d1159e253fdcab8efe0753.png";